import { render, staticRenderFns } from "./brand__form.vue?vue&type=template&id=79f40734"
import script from "./brand__form.vue?vue&type=script&lang=js"
export * from "./brand__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports